import React, { Component, PureComponent } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import './index.scss';
import moment from 'moment';
import _ from 'lodash';
export default class ModalContainer extends Component {
  state = { modal: {}, prizes:[], modalInfo:{} }
  addModal = (prizes, modalInfo, modal) => {
    console.log('modal add', modal)
    this.scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    document.body.style.cssText = `overflow: hidden; height: 100%; width: 100%; position: fixed; top:-${this.scrollTop}px`;
    modal.key = moment().valueOf()
    this.setState({ modal: modal, prizes: prizes, modalInfo: modalInfo })
  }

  removeModal = () => {
    console.log('onclose')
    const { modal } = this.state;
    if (modal) {
      console.log('modal close', modal)
      setTimeout(() => {
        const {modal} = this.state
        this.setState({modal: null});
        ReactDOM.unmountComponentAtNode(modal)
        window.document.body.removeChild(modal);
        // 滚动条归位
        document.body.style.cssText = null;
        window.scrollTo(0, this.scrollTop);
        // 释放dom引用
       
        return null;
      }, 0);
     return;
    }
  };

  render() {
    const { modal, prizes, modalInfo } = this.state;
    
    console.log('进modal 了。。。。。', modal)
    return (
      <>
      {modal && <div key={modal.key}>
        <div className={classnames('crgt-modal-mask')}></div>
        <div className="crgt-modal-wrap">
          <Modal onClose={this.removeModal} prizes={prizes} modalInfo={modalInfo} />
        </div>
      </div>}
      </>
    )

  }
}
const defaultData={
  prizes: [
    {
      promotionBagId: 1163745659515514881,
      promotionBagName: "极速打车10元立减优惠券",
      coupons: [
        {
        title: "极速打车优惠券",
        expireEndTime: 1569859199000,
        couponType: 1,
        cashCoupon: {
          couponAmount: 1000
        },
      },
      // {
      //   title: "极速打车优惠券",
      //   expireEndTime: 1569859199000,
      //   couponType: 2,
      //   discountCoupon: {
      //     discount: 750,
      //     orderAmount: 100,
      //     maximumDeduction: 1000
      //   },
      // },
      // {
      //   title: "极速打车优惠券",
      //   expireEndTime: 1569859199000,
      //   couponType: 3,
      //   fullReduceCoupon: {
      //     reduceAmount: 1000,
      //     orderAmount: 5000,
      //     maximumDeduction: 10000
      //   },
      // },
      // {
      //   title: "极速打车优惠券",
      //   expireEndTime: 1569859199000,
      //   couponType: 4,
      //   freeCoupon: {
      //     freeAmount: 5000
      //   },
      // },
    ]}]
}
class Modal extends PureComponent{
  render(){
    const {onClose, prizes,  modalInfo={}} = this.props;
    const {
      modalBgImg, modalCouponBg='https://static.ccrgt.com/images/109a046d-bc83-491e-b595-cd253fc5d8b1.png', modalCouponColor='#AF7E4A',modalCouponTitle='高铁影院', 
      modalCouponTitleColor, modalDescColor, modalNoteColor, modalButtonColor,modalButtonBg} = modalInfo; 
    console.log('modal', prizes)
    return(
      <div className="modal-content" style={{ backgroundImage: _.isEmpty(modalBgImg)?null:`url(${modalBgImg})`, backgroundSize: '100% 100%' }}>
        <div className="modal-close" onClick={onClose}></div>
        {
          prizes.map(prize => {
            return prize.coupons.map((item, index) => (
              <div className="modal-coupon">
              <Coupon
                key={index}
                couponBg={modalCouponBg}
                color={modalCouponColor}
                coupon={item}
                title={modalCouponTitle}
                titleColor={modalCouponTitleColor}
              />
              <div className="modal-coupon-desc" style={{color: _.isEmpty(modalDescColor) ? null : modalDescColor}}>恭喜您获得{prize.promotionBagName}</div>
              </div>
            ))
          })
        }
      
      <div className="modal-note" style={{color: _.isEmpty(modalNoteColor)?null:modalNoteColor}}>已放入“我的卡券”，请前往查看</div>
      <button className="modal-button" style={{color: _.isEmpty(modalButtonColor)?null:modalButtonColor, background:_.isEmpty(modalButtonBg)?null:modalButtonBg}} onClick={onClose}>去使用</button>
      </div>
    )
  }
}


class Coupon extends PureComponent{

  couponTypeHTML = (item) => {
    switch (item.couponType) {
      case 4:
        return <div className="modal-coupon-container-content-middle"><strong>免单</strong></div>
      case 3:
        return (
          <div className="modal-coupon-container-content-top">
            <em>{item.fullReduceCoupon.reduceAmount / 100}</em><span className="unit">元</span>
            <div className="modal-coupon-container-content-bottom">
             满减券
                  </div>
          </div>
        )
      case 2:
        return (
          <div className="modal-coupon-container-content-top">
            <em>{((item.discountCoupon.discount % 100) === 0) ? (item.discountCoupon.discount / 100) : (item.discountCoupon.discount / 100).toFixed(1)}</em><span className="unit">折</span>
            <div className="modal-coupon-container-content-bottom">
              折扣券
            </div>
          </div>
        )


      default:
        return (
          <div className="modal-coupon-container-content-top">
            <em>{item.cashCoupon.couponAmount / 100}</em><span className="unit">元</span>
            <div className="modal-coupon-container-content-bottom">
              立减券
            </div>
          </div>
        )

    }

  }

  render(){
    const {coupon, couponBg, color, title, titleColor } = this.props
    return(
    <div className="modal-coupon-container" style={{ backgroundImage: _.isEmpty(couponBg)?null:`url(${couponBg})` }}>
      <div className="modal-coupon-container-content" style={{color: _.isEmpty(color)?null:color}}>{this.couponTypeHTML(coupon)}</div>
      <div className="modal-coupon-container-title" style={{color: _.isEmpty(titleColor)?null:titleColor}}>{title}</div>
    </div>
    )
  }
}